/**
 * SO TARTE 商品ページ 複数フレーバー選択・予約フォーム
 * assets/tarte-product-form.js
 *
 * ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 * ★ オプション商品のvariant IDはここだけ編集してください
 * ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
 */
const ST_OPTIONS = {
  cold: {
    variantId:    null,     // ← 保冷オプションのvariant ID
    pricePerUnit: 1000,     // 30分単位 ¥10 = 1000 cents
    label:        '保冷オプション',
  },
  topper: {
    variantId: null,        // ← Happy Birthdayトッパーのvariant ID
    price:     50000,       // ¥500
    label:     'Happy Birthday トッパー',
  },
  plate: {
    variantId: null,        // ← ネームプレートのvariant ID
    price:     30000,       // ¥300
    label:     'ネームプレート',
  },
  candle: {
    variantId:  null,       // ← キャンドルのvariant ID
    freeQty:    3,          // 無料本数
    extraPrice: 3000,       // 4本目以降 ¥30 = 3000 cents
    label:      'キャンドル',
  },
  fork: {
    variantId:    null,     // ← フォークのvariant ID
    pricePerUnit: 5000,     // ¥50 = 5000 cents
    label:        'フォーク',
  },
  box_s: {
    variantId: null,        // ← 小BOXのvariant ID
    price:     11000,       // ¥110
    label:     '小BOX',
  },
  box_l: {
    variantId: null,        // ← 大BOXのvariant ID
    price:     25000,       // ¥250
    label:     '大BOX',
  },
};
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

(function () {
  'use strict';

  // ── State
  const state = {
    selected:       {},     // { variantId: qty }
    walkMin:        30,
    coldUnits:      0,
    coldPriceCents: 0,
    options: {
      topper: false,
      plate:  false,
    },
    optionQty: {
      candle: 0,
      fork:   0,
    },
    plateName:   '',
    currentBoxes: [],       // 自動計算されたボックス構成 [{key, qty}]
  };

  function fmt(cents) {
    return '¥' + (cents / 100).toLocaleString('ja-JP');
  }

  // ── ボックス構成を計算（8cmのみ）
  // 9個単位で大BOX、余り1-2個で小BOX
  function calcBoxes(totalQty) {
    if (totalQty === 0) return [];
    const largeSets = Math.floor(totalQty / 9);
    const remainder = totalQty % 9;
    const boxes = [];
    if (largeSets > 0) boxes.push({ key: 'box_l', qty: largeSets });
    if (remainder >= 3) boxes.push({ key: 'box_l', qty: 1 });
    else if (remainder >= 1) boxes.push({ key: 'box_s', qty: 1 });
    // remainderが0の場合は追加なし（9の倍数）
    return boxes;
  }

  // ── フレーバーカード トグル
  function toggleFlavor(card) {
    const id    = card.dataset.variantId;
    const qtyEl = card.querySelector('.stp__flavor-qty');
    if (state.selected[id]) {
      delete state.selected[id];
      card.classList.remove('stp__flavor-card--selected');
      if (qtyEl) qtyEl.style.display = 'none';
    } else {
      state.selected[id] = 1;
      card.classList.add('stp__flavor-card--selected');
      if (qtyEl) qtyEl.style.display = 'flex';
      const numEl = document.getElementById('qty-' + id);
      if (numEl) numEl.textContent = 1;
    }
    updateSummary();
  }

  // ── フレーバー個数変更
  function changeQty(id, delta) {
    if (!state.selected[id]) return;
    const next = Math.max(1, (state.selected[id] || 1) + delta);
    state.selected[id] = next;
    const numEl = document.getElementById('qty-' + id);
    if (numEl) numEl.textContent = next;
    updateSummary();
  }

  // ── オプション個数変更（キャンドル・フォーク）
  function changeOptionQty(key, delta) {
    const next = Math.max(0, (state.optionQty[key] || 0) + delta);
    state.optionQty[key] = next;
    const el = document.getElementById('opt-qty-' + key);
    if (el) el.textContent = next;
    updateSummary();
  }

// ── トグルオプション（トッパー・プレート）
function toggleOption(key) {
  state.options[key] = !state.options[key];
  const btn = document.getElementById('stp-opt-' + key);
  if (btn) btn.classList.toggle('is-active', state.options[key]);
  if (key === 'plate') {
    const wrap = document.getElementById('stp-plate-wrap');
    if (wrap) wrap.style.display = state.options.plate ? '' : 'none';
  }
  if (key === 'topper') {
    const wrap = document.getElementById('stp-topper-wrap');
    if (wrap) wrap.style.display = state.options.topper ? '' : 'none';
  }
  updateSummary();
}


  // ── 持ち歩き時間
  function updateWalk(val) {
    const min = parseInt(val, 10);
    state.walkMin = min;
    const valEl  = document.getElementById('stp-walk-val');
    const feeEl  = document.getElementById('stp-walk-fee');
    const hintEl = document.getElementById('stp-walk-hint');
    if (valEl) valEl.textContent = min;

    const extraSlots     = Math.max(0, Math.ceil((min - 60) / 30));
    state.coldUnits      = extraSlots;
    state.coldPriceCents = extraSlots * ST_OPTIONS.cold.pricePerUnit;

    if (feeEl) {
      feeEl.textContent = state.coldPriceCents === 0 ? '無料' : '+' + fmt(state.coldPriceCents);
      feeEl.className   = 'stp__walk-fee' + (state.coldPriceCents === 0 ? ' is-free' : '');
    }
    if (hintEl) {
      if (state.coldPriceCents === 0) {
        hintEl.textContent = '1時間以内は保冷オプション無料です。';
        hintEl.className   = 'stp__hint stp__hint--ok';
      } else {
        hintEl.textContent = `1時間超過：${extraSlots}個追加 → 保冷料 ${fmt(state.coldPriceCents)}`;
        hintEl.className   = 'stp__hint';
      }
    }
    updateSummary();
  }

  // ── サマリー更新
  function updateSummary() {
    state.plateName = (document.getElementById('stp-plate-name') || {}).value || '';

    const ids          = Object.keys(state.selected);
    const summaryLeft  = document.getElementById('stp-summary-left');
    const totalWrap    = document.getElementById('stp-total-wrap');
    const totalPriceEl = document.getElementById('stp-total-price');
    const addBtn       = document.getElementById('stp-add-btn');

    if (ids.length === 0) {
      if (summaryLeft) summaryLeft.innerHTML = '<p class="stp-summary__empty">タルトを選んでください</p>';
      if (totalWrap)   totalWrap.style.display = 'none';
      if (addBtn)      addBtn.disabled = true;
      return;
    }

    let totalCents = 0;
    const chips    = [];

    // フレーバー
    ids.forEach(id => {
      const card     = document.querySelector(`[data-variant-id="${id}"]`);
      const name     = card ? card.dataset.name : id;
      const price    = card ? parseInt(card.dataset.price, 10) : 0;
      const qty      = state.selected[id];
      const subtotal = price * qty;
      totalCents    += subtotal;
      chips.push(`<span class="stp-summary__chip">
        ${name}${qty > 1 ? ` ×${qty}` : ''}
        <span class="stp-summary__chip-price">${fmt(subtotal)}</span>
      </span>`);
    });

    // ボックス代（8cmのみ自動計算）
    if (window.STP_DATA?.is8cm) {
      const totalQty = ids.reduce((sum, id) => sum + state.selected[id], 0);
      const boxes    = calcBoxes(totalQty);
      state.currentBoxes = boxes;

      boxes.forEach(({ key, qty }) => {
        const box   = ST_OPTIONS[key];
        const price = box.price * qty;
        totalCents += price;
        chips.push(`<span class="stp-summary__chip stp-summary__chip--opt">
          📦 ${box.label}${qty > 1 ? ` ×${qty}` : ''}
          <span class="stp-summary__chip-price">${fmt(price)}</span>
        </span>`);
      });
    }

    // トグルオプション（トッパー・プレート）
    ['topper', 'plate'].forEach(key => {
      if (!state.options[key]) return;
      const opt  = ST_OPTIONS[key];
      let label  = opt.label;
      if (key === 'plate' && state.plateName) label += `「${state.plateName}」`;
      totalCents += opt.price;
      chips.push(`<span class="stp-summary__chip stp-summary__chip--opt">
        ${label}
        <span class="stp-summary__chip-price">${fmt(opt.price)}</span>
      </span>`);
    });

    // キャンドル
    if (state.optionQty.candle > 0) {
      const q          = state.optionQty.candle;
      const extra      = Math.max(0, q - ST_OPTIONS.candle.freeQty);
      const price      = extra * ST_OPTIONS.candle.extraPrice;
      totalCents      += price;
      const priceLabel = price === 0 ? '無料' : fmt(price);
      chips.push(`<span class="stp-summary__chip stp-summary__chip--opt">
        🕯️ キャンドル ${q}本
        <span class="stp-summary__chip-price">${priceLabel}</span>
      </span>`);
    }

    // フォーク
    if (state.optionQty.fork > 0) {
      const q     = state.optionQty.fork;
      const price = q * ST_OPTIONS.fork.pricePerUnit;
      totalCents += price;
      chips.push(`<span class="stp-summary__chip stp-summary__chip--opt">
        🍴 フォーク ${q}本
        <span class="stp-summary__chip-price">${fmt(price)}</span>
      </span>`);
    }

    // 保冷
    if (state.coldPriceCents > 0) {
      totalCents += state.coldPriceCents;
      chips.push(`<span class="stp-summary__chip stp-summary__chip--opt">
        🧊 保冷（${state.walkMin}分）
        <span class="stp-summary__chip-price">${fmt(state.coldPriceCents)}</span>
      </span>`);
    }

    if (summaryLeft)  summaryLeft.innerHTML = `<div class="stp-summary__chips">${chips.join('')}</div>`;
    if (totalWrap)    totalWrap.style.display = '';
    if (totalPriceEl) totalPriceEl.textContent = fmt(totalCents);
    if (addBtn)       addBtn.disabled = false;
  }

  // ── カートに追加
  async function addToCart() {
    const ids = Object.keys(state.selected);
    if (!ids.length) { alert('タルトを選択してください。'); return; }

    const btn = document.getElementById('stp-add-btn');
    if (btn) { btn.disabled = true; btn.textContent = '処理中…'; }

    const props = { '持ち歩き時間': state.walkMin + '分' };
    const items = ids.map(id => ({
      id:         parseInt(id, 10),
      quantity:   state.selected[id],
      properties: props,
    }));

    // ボックス（8cmのみ自動追加）
    if (window.STP_DATA?.is8cm && state.currentBoxes.length > 0) {
      state.currentBoxes.forEach(({ key, qty }) => {
        const box = ST_OPTIONS[key];
        if (box.variantId) {
          items.push({ id: box.variantId, quantity: qty, properties: props });
        }
      });
    }

    // トグルオプション（トッパー・プレート）
    ['topper', 'plate'].forEach(key => {
      if (!state.options[key]) return;
      const opt = ST_OPTIONS[key];
      if (!opt.variantId) return;
      const p = { ...props };
      if (key === 'plate' && state.plateName) p['お名前'] = state.plateName;
      items.push({ id: opt.variantId, quantity: 1, properties: p });
    });

    // キャンドル
    if (state.optionQty.candle > 0 && ST_OPTIONS.candle.variantId) {
      items.push({
        id:         ST_OPTIONS.candle.variantId,
        quantity:   state.optionQty.candle,
        properties: props,
      });
    }

    // フォーク
    if (state.optionQty.fork > 0 && ST_OPTIONS.fork.variantId) {
      items.push({
        id:         ST_OPTIONS.fork.variantId,
        quantity:   state.optionQty.fork,
        properties: props,
      });
    }

    // 保冷
    if (state.coldUnits > 0 && ST_OPTIONS.cold.variantId) {
      items.push({
        id:         ST_OPTIONS.cold.variantId,
        quantity:   state.coldUnits,
        properties: props,
      });
    }

    try {
      const res  = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ items }),
      });
      const data = await res.json();
      if (data.status) {
        alert('エラーが発生しました：' + (data.description || data.message));
        if (btn) { btn.disabled = false; btn.textContent = 'カートに入れる'; }
      } else {
        window.location.href = window.STP_DATA?.cartUrl || '/cart';
      }
    } catch (e) {
      console.error(e);
      alert('通信エラーが発生しました。');
      if (btn) { btn.disabled = false; btn.textContent = 'カートに入れる'; }
    }
  }

  // ── 日付初期化（2営業日後・月曜日曜除く）
  function initDate() {
    const input = document.getElementById('stp-date');
    if (!input) return;
    const d = new Date();
    let count = 0;
    while (count < 2) {
      d.setDate(d.getDate() + 1);
      const dow = d.getDay();
      if (dow !== 0 && dow !== 1) count++;
    }
    if (new Date().getHours() >= 12) {
      d.setDate(d.getDate() + 1);
      while (d.getDay() === 0 || d.getDay() === 1) d.setDate(d.getDate() + 1);
    }
    input.addEventListener('input', function () {
      const dow = new Date(this.value).getDay();
      if (dow === 0 || dow === 1) {
        this.setCustomValidity('月曜・日曜は定休日です');
        this.reportValidity();
        this.value = '';
      } else {
        this.setCustomValidity('');
      }
    });
    const str   = d.toISOString().split('T')[0];
    input.min   = str;
    input.value = str;
  }

  // ── Public API
  window.STP = {
    toggleFlavor,
    changeQty,
    changeOptionQty,
    toggleOption,
    updateWalk,
    updateSummary,
    addToCart,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDate);
  } else {
    initDate();
  }
})();